import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../contexts/CartContext';
import { formatMoney } from '../../lib/shopify';
import { QuantitySelector } from './QuantitySelector';
import type { CartLine } from '../../types/commerce';
export function CartItem({
  line,
  onNavigate
}: {
  line: CartLine;
  onNavigate?: () => void;
}) {
  const {
    setQuantity,
    remove
  } = useCart();
  const {
    product,
    quantity
  } = line;
  return <li className="flex gap-4 border-b border-white/10 py-6 first:pt-0" data-id="element-235" data-mp="2zfp8mvfr5pgq">
      <Link to={`/product/${product.handle}`} onClick={onNavigate} className="h-24 w-20 shrink-0 overflow-hidden rounded-2xl bg-white/5" data-id="element-236" data-mp="2ue9or6pb9ozx">
        <img src={product.images[0]} alt="" className="h-full w-full object-cover" data-id="element-237" data-mp="2khn1kb9iiluq" />
      </Link>

      <div className="flex min-w-0 flex-1 flex-col" data-id="element-238" data-mp="nnjyy2g18k3x">
        <div className="flex items-start justify-between gap-3" data-id="element-239" data-mp="iq07g0ubqau1">
          <div className="min-w-0" data-id="element-240" data-mp="iqjshqf9tfca">
            <Link to={`/product/${product.handle}`} onClick={onNavigate} className="block truncate text-base font-medium transition-colors duration-150 hover:text-beat-red" data-id="element-241" data-mp="zh1d6evnb1ti">
              {product.name}
            </Link>
            <p className="mt-1 text-sm text-white/45" data-id="element-242" data-mp="pkyexk3wznbu">
              {product.packLabel} · {product.cans} cans
            </p>
          </div>
          <p className="shrink-0 text-base font-medium tabular-nums" data-id="element-243" data-mp="1i6zod3uqpb1d">
            {formatMoney(product.price.amount * quantity, product.price.currencyCode)}
          </p>
        </div>

        <div className="mt-4 flex items-center justify-between gap-3" data-id="element-244" data-mp="18gwt0x05bkzv">
          <QuantitySelector size="sm" value={quantity} onChange={next => setQuantity(product.handle, next)} label={`Quantity for ${product.name} ${product.packLabel}`} data-id="element-245" data-mp="1dfhjw5ticsbn" />
          <button type="button" onClick={() => remove(product.handle)} className="text-sm text-white/40 transition-colors duration-150 hover:text-beat-red" data-id="element-246" data-mp="25y50p91h1l6x">
            Remove
          </button>
        </div>
      </div>
    </li>;
}